import React, { useEffect, useState } from 'react';
import { authFetch, API } from '../api';
import StationApp from './StationApp';
import CartApp from './CartApp';
import { guidedText } from './guidedText';

// /pp — the guided P&P screen (phase 4, 2026-10-17; docs/GUIDED-PP.md). One address for both kinds of shared
// screen: the server says whether this login is a P&P station or a cart's tablet (Settings → Badges & rights →
// Devices) and the matching app opens. A registered device stays signed in while its screen runs: the token is
// refreshed every hour (POST /api/auth/refresh), so nobody types a password at the cart in the morning — and if it
// does expire, the next login lands on the server's round, never on a list the browser kept.

export default function PpApp() {
  const [who, setWho] = useState<{ device: { kind: string; station_no: number | null; cart_id: string | null } | null } | null>(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    authFetch(`${API}/pp2/whoami`).then(async r => {
      if (r.status === 401) { window.location.href = '/'; return; }
      if (!r.ok) { setErr(`HTTP ${r.status}`); return; }
      setWho(await r.json());
    }).catch(() => setErr('No connection to the WMS'));
  }, []);

  useEffect(() => {
    if (!who?.device) return;
    const refresh = () => authFetch(`${API}/auth/refresh`, { method: 'POST' }).then(async r => {
      if (!r.ok) return;
      const d = await r.json();
      if (d.token) localStorage.setItem('wms_token', d.token);
    }).catch(() => {});
    refresh();
    const t = setInterval(refresh, 3600_000);
    return () => clearInterval(t);
  }, [who]);

  if (err) return <div className="fixed inset-0 bg-[#0f1117] text-red-400 flex items-center justify-center">{err}</div>;
  if (!who) return <div className="fixed inset-0 bg-[#0f1117] text-gray-400 flex items-center justify-center">Loading…</div>;
  if (!who.device) {
    return (
      <div className="fixed inset-0 bg-[#0f1117] text-gray-200 flex items-center justify-center p-8 text-center text-lg max-w-2xl mx-auto">
        {guidedText('en').notRegistered}
      </div>
    );
  }
  return who.device.kind === 'tablet' ? <CartApp /> : <StationApp />;
}
